import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import {
  SCAuthorLabel, SCHamburgerWrapp,
  SCHeader,
  SCHeaderBlogLink,
  SCLibraryLabel,
  SCTriangleArrow,
} from '~/atomic/organism/Header/Header';
import { SCHeaderNotificationIcon } from '~/atomic/organism/Header/styled';
import { SCAlert } from '~/feature/Alert';
import { SCSearchIcon } from '~/feature/search/ShowSearchButton';
import { SiteTemplate } from '~/feature/template/SiteTemplate';
import { SCArrow, SCAvatarWrapper } from '~/feature/user/UserInfo';
import { lessThan } from '~/lib/mediaQuery';
import { WithChildren } from '~/lib/WithChildren';

export const LandingLayout: FC<{ headerBackground: ReactNode } & WithChildren> = (
  { children, headerBackground },
) => {
  return (
    <SCLandingLayout>
      <SCHeaderImage>
        { headerBackground }
      </SCHeaderImage>
      <SiteTemplate>
        { children }
      </SiteTemplate>
    </SCLandingLayout>
  );
};

const SCHeaderImage = styled.div`
  position: relative;
  z-index: 1;
`;

const SCLandingLayout = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: #fafdff;
  
  ${SCAlert} {
    display: none;
  }
  
  ${SCHeader} { 
    z-index: 3;
    background: transparent;
    
    ${SCHamburgerWrapp} span.site-header__hamburger-inner {
      ${lessThan('md')} {
        background-color: var(--white-color) !important;
        
        &:before {
           background-color: var(--white-color) !important;
        }
          
        &:after {
           background-color: var(--white-color) !important;
        }
      }
    }
    
     ${SCArrow} {
       filter: invert();
     }
    
    ${SCAvatarWrapper} {
      position: relative;
      z-index: 2;
      
      span {
        color: var(--white-color)
      }
      
      .ant-avatar {
        position: relative;
        
        &:before{
          display: block;
          width: 44px;
          height: 44px;
          content: "";
          background-image: url('/image/landing-avatar.svg');
          top: 0;
          left: 0;
        }
        
        img {
          opacity: 0;
        }
      }
    }
    
    
    ${SCSearchIcon} {
      position: relative;
      z-index: 3;
      
       @media only screen and (max-width: 1280px) {
         fill: var(--white-color);
       }
    }
    
    ${SCAuthorLabel} {
      position: relative;
      z-index: 3;
      color: var(--white-color);
    }
    
    ${SCLibraryLabel} {
      @media only screen and (max-width: 1400px) {
         color: var(--white-color);
         
         ${SCTriangleArrow} {
            background-color: var(--white-color);
         }
      }
    }
        
    
    ${SCHeaderBlogLink} {
      position: relative;
      color: var(--black-color);
      z-index: 3;
      
      @media only screen and (max-width: 1680px) {
         color: var(--white-color);
      }
    }
  }
  
  ${SCHeaderNotificationIcon} {
    color: var(--white-color);
  }
`;
